import { useMatches as useRouterMatches } from 'react-router-dom';

import type { Match } from 'app/providers/RouterProvider';

export const useMatches = () => useRouterMatches() as Match[];
